import { cn } from '@/lib/utils';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export function Label({ required, className, children, ...props }: LabelProps) {
  return (
    <label
      className={cn(
        'text-sm font-medium text-foreground cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="ml-1 text-danger" aria-label="required">*</span>}
    </label>
  );
}
